window.Project = function() {
    var el = this;
    var autosaveId = 0;
    el.current = {};
    
    el.reset = function() {
        el.current.constructor = {};
    };
    
    el.load = function(sid) {
        var init = false;
        el.loader.show(Yii.t('Loading project...'));
        el.request.get(window.requestUrls.project.get + sid, function(response) {
            el.loader.hide();
            
            if (response.hasOwnProperty('error')) {
                alert(response.error);
                return false;
            }

            if (response.hasOwnProperty('project')) {
                // if (parseInt($.cookie('saved_company')) !== parseInt(response.project.company_id)) {
                //     alert(Yii.t('The selected project is linked to another company.'));
                //     return false;
                // }

                window.bookSid = response.project.id + '_' + response.project.hash;
                el._parent.isCheckingOnloadStatus = true;
                el._parent.workData = {};
                el.current = response.project;

                el.format.init();
                el.color.init();
                el.size.init();
                el.language.init()
                
                if (parseInt(el.category.group_id) === el.CALENDAR_GROUP_ID && parseInt(el.description.show_calendar_date) === 1) {
                    el.calendarGrid.showPanel();
                }
                
                if (Object.keys(response.project.constructor).length > 0 && Object.keys(response.project.constructor.workareas).length > 0 && !init) {
                    el._parent.workData = response.project.constructor;
                    el._parent.selectWorkareaId = Object.keys(el.workData.workareas)[0];
                    init = true;
                }

                var firstInit = false;
                if (parseInt(el.current.template_id) !== 0 && !init) {
                    var template = el.template.get(el.current.template_id);

                    if (template.hasOwnProperty('data') && template.data.hasOwnProperty('language')) {
                        el.language.set(template.data.language);
                    }

                    if (template !== false) {
                        firstInit = true;
                        el.workarea.init(template.data, firstInit);
                        init = true;
                    }
                }
                
                if (parseInt(el.category.is_show_custom_design) === 0 && !init) {
                    var template = el.template.getFirst();
                    if (template !== false) {
                        firstInit = true;
                        el.workarea.init(template.data, firstInit);
                        init = true;
                    }
                }

                if (response.project.calculator.hasOwnProperty('count') && response.project.calculator.count !== 0) {
                    el.calculator.count = response.project.calculator.count;
                }

                if (!init) {
                    el.workarea.init();
                }

                if (Object.keys(response.project.constructor).length === 0 && response.project.template_id === null && window.new_template == 0) {
                    var template = el.template.getFirst();
                    if (template !== false) {
                        el.template.show();
                    }
                }

                el.calendarGrid.init();
                el.grid.init();
                el.calculator.init();
                el.format.render();
                el.color.render();
                el.size.render();
                
                el.upImages.init();
                el.preview.render();
                el.workarea.render();
                el.startAutoSave();
                el.history.init();

                if (firstInit && parseInt(el.description.enable_auto_distribution)) {
                    var count = el.cell.getCountEmptyCells();
                    el.dialog.show('confirm', {
                        message: Yii.t('Choose an option for placing photos on the template'),
                        cancelText: Yii.t('Frame yourself'),
                        cancelEvent: 'bookConstructor.upImages.setDistribution(0)',
                        continueText: Yii.t('Autocomplete (Requires {count} photo)', {count}),
                        continueEvent: 'bookConstructor.upImages.setDistribution(1);bookConstructor.showContainer("upload-page");'
                    });
                }
            }
        }, 'json');
    };
    
    el.save = function(cb) {
        el.loader.show(Yii.t('Saving a project...'));

        var data = {
            product_id: el.product.id,
            template_id: el.project.current.template_id,
            data: JSON.stringify(el.workData)
        };
        
        el.request.post(window.requestUrls.project.update + window.bookSid, data, function (response) {
            el.loader.hide();
            if (response.hasOwnProperty('error')) {
                el.loader.hide();

                clearTimeout(autosaveId);

                el.dialog.show('message', {
                    message: Yii.t('Error saving project') + ': ' + response.error + '<br>'
                        + Yii.t('Refresh the page to get the latest successful version'),
                });

                return false;
            } else {
                if (cb !== undefined) {
                    cb();
                }
            }
        }, 'json', false);
    };
    
    el.startAutoSave = function() {
        autosaveId = setInterval(function() {
            var data = {
                product_id: el.product.id,
                template_id: el.project.current.template_id,
                data: JSON.stringify(el.workData)
            };
        
            el.request.post(window.requestUrls.project.update + window.bookSid, data, function (response) {
                if (response.hasOwnProperty('error')) {
                    clearTimeout(autosaveId);

                    el.dialog.show('message', {
                        message: Yii.t('Error saving project') + ': ' + response.error + '<br>'
                            + Yii.t('Refresh the page to get the latest successful version'),
                    });
                }
            }, 'json');
        }, 30000);
    };

    el.stopAutoSave = function () {
        clearTimeout(autosaveId);
    };
    
    $(document).on('click', '.js-project-save', function () {
        el.save();
    });
};